import { Pipe, PipeTransform } from '@angular/core';
import { UK_Zones } from 'src/app/core/constants/ZonesIds';

@Pipe({
  name: 'CurrencyByZoneId'
})
export class CurrencyByZoneId implements PipeTransform {
  transform(zoneId: string | undefined): string {
    if (zoneId) {
      if (UK_Zones.includes(zoneId)) {
        return "£";
      }
    }
    return "€";
  }
}